import { EEthereumNetworkId } from '@ankr.com/provider';
import BigNumber from 'bignumber.js';
import config from 'config';

export const CONTENT_MAX_WIDTH = 1180;

export const DOCUMENTATION_LINK = process.env.REACT_APP_DOCUMENTATION_LINK;
export const FEEDBACK_LINK = process.env.REACT_APP_FEEDBACK_LINK;

export const EMAIL_LINK = process.env.REACT_APP_EMAIL_LINK;

export const TWITTER_LINK = process.env.REACT_APP_TWITTER_LINK;
export const TELEGRAM_LINK = process.env.REACT_APP_TELEGRAM_LINK;
export const MEDIUM_LINK = process.env.REACT_APP_MEDIUM_LINK;
export const DISCORD_LINK = process.env.REACT_APP_DISCORD_LINK;

export const ZERO = new BigNumber(0);

export const ONE = new BigNumber(1);

export const DAYS_PER_WEEK = 7;

export const HOMEPAGE = 'dashboard';

export const WALLET_PARAM_ID = 'wallet';

export const AVAILABLE_CHAINS = Object.keys(config).map(
  Number,
) as EEthereumNetworkId[];

export const CHAIN_UNIT = {
  [EEthereumNetworkId.polygon]: 'polygon',
  [EEthereumNetworkId.mumbai]: 'mumbai',
  [EEthereumNetworkId.smartchain]: 'smartchain',
  [EEthereumNetworkId.smartchainTestnet]: 'smartchain_testnet',
};

export enum ErrorMessage {
  ConfigIsNotDefined = 'Config is not defined',
  ChainIdIsNotDefined = 'Chain id is not defined',
  ProviderIsNotValid = 'Provider is not valid',
}
